/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Add_RowInputs */

const vi_shop_home_add_row = /** @type {(inputs: Shop_Home_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm dòng`)
};

/**

* @param {Shop_Home_Add_RowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_add_row = /** @type {((inputs?: Shop_Home_Add_RowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Add_RowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_add_row(inputs)
});